





















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Asset } from "@foxone/api/src/models/defi";

@Component
class ContractHold extends Vue {
  @Prop({ type: Object, default: () => ({}) }) asset!: Asset;

  @Prop({ type: Number, default: 0 }) quantity!: number;

  @Prop({ type: Number, default: 0 }) remainRevenue!: number;

  @Prop({ type: Number, default: 0 }) totalRevenue!: number;

  @Prop({ type: Number, default: 0 }) lastRevenue!: number;

  get meta() {
    const getColor = this.$common.utils.helper.getColor;
    const addSymbol = this.$common.utils.number.addSymbol;

    const { asset, quantity, remainRevenue, totalRevenue, lastRevenue } = this;
    const totalQuantity = (quantity + remainRevenue).toFixed(8);

    return {
      totalQuantity,
      symbol: asset.symbol.toUpperCase(),
      totalRevenue,
      totalRevenueColor: getColor(this.$store, totalRevenue),
      lastRevenue: addSymbol(lastRevenue),
      lastRevenueColor: getColor(this.$store, lastRevenue)
    };
  }
}
export default ContractHold;
